module.exports = __webpack_public_path__ + "static/media/newInsta.69cfc5cd.svg";